import { ApolloProvider } from '@apollo/react-hooks'
import { App } from 'app'
import { loadAppInsights } from 'appInsights'
import { initMsal } from 'auth'
import { CommandsProvider } from 'components'
import { SearchProvider } from 'components/SearchProvider/SearchProvider'
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons'
import * as React from 'react'
import { ApolloProvider as ApolloHooksProviderDeprecated } from 'react-apollo-hooks'
import * as ReactDOM from 'react-dom'
import { RouterProvider } from 'react-router5'
import { createApolloClient } from './apollo'
import { initializeI18n } from './i18n'
import { localizeYup } from './i18n/helpers'
import { createRouter, State } from './router'
import routes from './routes'
import * as serviceWorker from './serviceWorker'
import { ThemeProvider } from './theme'

// Frame-busting: Prevent the app from being loaded inside an iframe
if (window.self !== window.top) {
  // If the app is in an iframe, redirect to the top window
  if (window.top) {
    window.top.location = window.self.location
  }
}

const resourceFileContext = require.context(
  '.',
  true,
  /locales\/.*.json/,
  'sync'
)

function fixGlobalReactError() {
  ;(global as any).React = React // idk
}

fixGlobalReactError()
initializeIcons(
  'https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001/assets/icons/',
);

const router = createRouter(routes, {
  useLogger: process.env.NODE_ENV !== 'production',
})

Promise.all([
  initializeI18n({ resourceFileContext }),
  new Promise<State | undefined>((resolve, reject) =>
    router.start((err, state) => {
      if (err) {
        reject(err)
      } else {
        resolve(state)
      }
    })
  ),
  // persistCache({
  //   cache: apolloClient.cache,
  //   storage: window.localStorage as any,
  // }),
]).then(([t, state]) =>
  initMsal(() => {
    const apolloClient = createApolloClient()
    loadAppInsights(router, state)
    localizeYup(t!)

    ReactDOM.render(
      <RouterProvider router={router}>
        <ApolloHooksProviderDeprecated client={apolloClient}>
          <ApolloProvider client={apolloClient}>
            <ThemeProvider>
              <CommandsProvider>
                <SearchProvider>
                  <App />
                </SearchProvider>
              </CommandsProvider>
            </ThemeProvider>
          </ApolloProvider>
        </ApolloHooksProviderDeprecated>
      </RouterProvider>,
      document.getElementById('root')
    )
  })
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
